import { cn } from "@/lib/utils";
import { PRIVATE_ANSWERS_DISCLAIMER } from "@/components/storyboard/InputPrivacyNotice";

interface PrivateAnswersDisclaimerProps {
  className?: string;
}

/**
 * Visibility note on self- and experience-reflection — tells the learner
 * their answers are not shown to others in the product UI.
 */
const PrivateAnswersDisclaimer = ({
  className,
}: PrivateAnswersDisclaimerProps) => (
  <p className={cn("text-sm text-muted-foreground", className)}>
    {PRIVATE_ANSWERS_DISCLAIMER}
  </p>
);

export default PrivateAnswersDisclaimer;
